import { Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider, useSession } from './session';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { CompaniesPage } from './pages/Companies';
import { CompanyPage } from './pages/Company';
import { ContactsPage } from './pages/Contacts';
import { ContactPage } from './pages/Contact';
import { InboxPage } from './pages/Inbox';
import { AgentsPage } from './pages/Agents';
import { PipelinePage } from './pages/Pipeline';
import { DealPage } from './pages/Deal';
import { TasksPage } from './pages/Tasks';
import { PipelineSettingsPage } from './pages/PipelineSettings';
import { ImportsPage } from './pages/Imports';
import { ImportJobPage } from './pages/ImportJob';
import { ProductsPage } from './pages/Products';
import { QuotesPage } from './pages/Quotes';
import { QuotePage } from './pages/Quote';
import { QuoteSettingsPage } from './pages/QuoteSettings';
import { MailboxPage } from './pages/Mailbox';
import { InvoicesPage } from './pages/Invoices';
import { InvoicePage } from './pages/Invoice';
import { InvoicingSettingsPage } from './pages/InvoicingSettings';
import { ReportsPage } from './pages/Reports';

function Routed() {
  const s = useSession();
  if (s.loading) return <div className="center muted">Betöltés…</div>;
  if (!s.me) return <LoginPage />;
  if (!s.entityId) return <div className="center">Nincs olyan cég, amelyhez hozzáférésed van. Kérd a tulajdonost, hogy adjon hozzá.</div>;
  // A nap a „Teendők és jóváhagyások” listával indul – ha van ügynökréteg; AI nélkül a napi feladatlistával (R7: nincs üres AI-oldal).
  const home = s.on('ai.agents') ? '/teendok' : '/feladatok';
  return (
    <Layout>
      <Routes key={s.entityId}>
        <Route path="/" element={<Navigate to={home} replace />} />
        {s.on('ai.agents') && <Route path="/teendok" element={<InboxPage />} />}
        {s.on('ai.agents') && <Route path="/ugynokok" element={<AgentsPage />} />}
        <Route path="/cegek" element={<CompaniesPage />} />
        <Route path="/cegek/:id" element={<CompanyPage />} />
        <Route path="/kontaktok" element={<ContactsPage />} />
        <Route path="/kontaktok/:id" element={<ContactPage />} />
        <Route path="/ertekesites" element={<PipelinePage />} />
        {(s.role === 'owner' || s.role === 'admin') && <Route path="/ertekesites/beallitasok" element={<PipelineSettingsPage />} />}
        <Route path="/ertekesites/:id" element={<DealPage />} />
        <Route path="/feladatok" element={<TasksPage />} />
        <Route path="/ajanlatok" element={<QuotesPage />} />
        {s.role === 'owner' && <Route path="/ajanlatok/beallitasok" element={<QuoteSettingsPage />} />}
        <Route path="/ajanlatok/:id" element={<QuotePage />} />
        <Route path="/termekek" element={<ProductsPage />} />
        <Route path="/beallitasok/postafiok" element={<MailboxPage />} />
        {s.role !== 'support' && <Route path="/szamlak" element={<InvoicesPage />} />}
        {s.role === 'owner' && <Route path="/szamlak/beallitasok" element={<InvoicingSettingsPage />} />}
        {s.role !== 'support' && <Route path="/szamlak/:id" element={<InvoicePage />} />}
        {s.role !== 'support' && <Route path="/riportok" element={<ReportsPage />} />}
        {(s.role === 'owner' || s.role === 'admin') && <Route path="/import" element={<ImportsPage />} />}
        {(s.role === 'owner' || s.role === 'admin') && <Route path="/import/:id" element={<ImportJobPage />} />}
        <Route path="*" element={<Navigate to={home} replace />} />
      </Routes>
    </Layout>
  );
}

export function App() {
  return <SessionProvider><Routed /></SessionProvider>;
}
